export const getQueryParamValue = (
  name: string,
  searchInHash?: boolean,
): string | undefined => {
  let searchString = window.location.search;

  if (searchInHash && searchString === "") {
    if (window.location.hash) {
      const searchElements = window.location.hash.split(`${name}=`);

      if (searchElements.length > 0) {
        return `${searchElements[searchElements.length - 1]}`;
      }
    }
  }

  const searchParams = new URLSearchParams(searchString.substring(1));
  const result = searchParams.get(name);

  return result ?? undefined;
};

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null;

  return (...args: Parameters<T>) => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}
